/* AVRA_CONSENT (2026-10-10)
   Cookie banner, Kate & Kole style: a white card at the bottom of the screen
   (centred card on desktop) with the message, a Privacy Policy link, Accept,
   Decline, and Manage preferences.

   It is wired to Shopify's own Customer Privacy API, so the choice is real:
     Accept  -> analytics, marketing, preferences and sale-of-data all allowed
     Decline -> all four refused (Shopify, its pixels and apps that respect the
                API stop tracking)
     Manage  -> she switches Analytics / Marketing / Preferences individually
   The banner shows on any page until she has made a choice, then never again
   on that browser. Shopify remembers the choice itself; a small localStorage
   flag is only a backup so it does not flash on every page while Shopify
   loads. Nothing is pre-ticked in Manage preferences except what she had. */
(function () {
  'use strict';
  var KEY = 'avra_consent_v1';
  var PRIVACY_URL = '/policies/privacy-policy';
  var saved = null;
  try { saved = localStorage.getItem(KEY); } catch (e) {}

  function api() { return window.Shopify && window.Shopify.customerPrivacy; }

  function loadApi(cb) {
    if (api()) { cb(api()); return; }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        cb(err ? null : api());
      });
    } else {
      cb(null);
    }
  }

  function decided(cp) {
    if (saved) return true;
    if (!cp || typeof cp.getTrackingConsent !== 'function') return false;
    try { return cp.getTrackingConsent() !== 'no_interaction'; } catch (e) { return false; }
  }

  var css = [
    '.acs{position:fixed;z-index:2147482000;left:50%;bottom:18px;width:calc(100% - 28px);max-width:560px;transform:translate(-50%,24px);opacity:0;background:#fff;color:#1a1813;border:1px solid rgba(26,24,19,.12);box-shadow:0 18px 50px rgba(0,0,0,.16);padding:28px 30px 24px;max-height:calc(100vh - 36px);max-height:calc(100dvh - 36px);overflow:auto;-webkit-overflow-scrolling:touch;font-family:var(--serif,"Cormorant Garamond","EB Garamond",Georgia,serif);transition:transform .45s cubic-bezier(.2,.8,.2,1),opacity .45s ease}',
    '.acs.is-in{transform:translate(-50%,0);opacity:1}',
    '.acs__txt{margin:0 0 20px;font-size:17px;line-height:1.5}',
    '.acs__txt a{color:inherit;text-decoration:underline;text-underline-offset:3px}',
    '.acs__btns{display:flex;flex-direction:column;gap:12px}',
    '.acs__btn{width:100%;padding:13px 16px;border:1.2px solid #1a1813;background:#fff;color:#1a1813;font:inherit;font-size:17px;letter-spacing:.02em;cursor:pointer;transition:background .2s,color .2s}',
    '.acs__btn:hover,.acs__btn:focus-visible{background:#1a1813;color:#fff;outline:none}',
    '.acs__manage{display:block;margin:16px auto 0;border:0;background:none;color:#1a1813;font:inherit;font-size:16px;text-decoration:underline;text-underline-offset:3px;cursor:pointer}',
    '.acs__prefs{display:flex;flex-direction:column;gap:12px;margin:0 0 18px}',
    '.acs__prefs[hidden]{display:none}',
    '.acs__row{display:flex;align-items:flex-start;justify-content:space-between;gap:16px;padding:12px 0;border-top:1px solid rgba(26,24,19,.1);font-size:15px;line-height:1.45}',
    '.acs__row b{display:block;font-weight:500;font-size:16px;margin-bottom:2px}',
    '.acs__row small{color:#646052;font-size:13.5px}',
    '.acs__row input{flex:0 0 auto;width:18px;height:18px;margin-top:3px;accent-color:#1a1813;cursor:pointer}',
    '@media(min-width:750px){.acs{bottom:28px;padding:30px 34px 26px}.acs__btns{flex-direction:row}.acs__btn{flex:1}}',
    '@media(prefers-reduced-motion:reduce){.acs{transition:opacity .2s ease}}'
  ].join('\n');

  function show(cp) {
    var st = document.createElement('style');
    st.textContent = css;
    document.head.appendChild(st);

    var box = document.createElement('div');
    box.className = 'acs';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-live', 'polite');
    box.setAttribute('aria-label', 'Cookie preferences');
    box.innerHTML =
      '<p class="acs__txt">AVRA uses browser cookies to help provide you with an exceptional experience, and to understand how the site is used. For more details, visit our <a href="' + PRIVACY_URL + '">Privacy Policy</a>.</p>' +
      '<div class="acs__prefs" data-acs-prefs hidden>' +
        '<label class="acs__row"><span><b>Essential</b><small>Keeps your bag, checkout and account working. Always on.</small></span><input type="checkbox" checked disabled></label>' +
        '<label class="acs__row"><span><b>Analytics</b><small>Helps us see which pages and pieces you enjoy.</small></span><input type="checkbox" data-acs="analytics"></label>' +
        '<label class="acs__row"><span><b>Marketing</b><small>Lets us show you AVRA on other sites and measure our ads.</small></span><input type="checkbox" data-acs="marketing"></label>' +
        '<label class="acs__row"><span><b>Preferences</b><small>Remembers choices like your wishlist and region.</small></span><input type="checkbox" data-acs="preferences"></label>' +
      '</div>' +
      '<div class="acs__btns">' +
        '<button type="button" class="acs__btn" data-acs-accept>Accept</button>' +
        '<button type="button" class="acs__btn" data-acs-decline>Decline</button>' +
      '</div>' +
      '<button type="button" class="acs__manage" data-acs-manage>Manage preferences</button>';
    document.body.appendChild(box);
    void box.offsetWidth;
    setTimeout(function () { box.classList.add('is-in'); }, 400);

    function finish(consent) {
      try { localStorage.setItem(KEY, JSON.stringify(consent)); } catch (e) {}
      var done = function () {
        box.classList.remove('is-in');
        setTimeout(function () { box.remove(); }, 450);
      };
      var c = cp || api();
      if (c && typeof c.setTrackingConsent === 'function') {
        try { c.setTrackingConsent(consent, done); } catch (e) { done(); }
        setTimeout(done, 1500); /* never leave the card up if Shopify is slow */
      } else {
        done();
      }
    }

    var prefs = box.querySelector('[data-acs-prefs]');
    var manage = box.querySelector('[data-acs-manage]');
    var accept = box.querySelector('[data-acs-accept]');

    accept.addEventListener('click', function () {
      if (!prefs.hidden) {
        var pick = function (k) { var i = box.querySelector('[data-acs="' + k + '"]'); return !!(i && i.checked); };
        var mk = pick('marketing');
        finish({ analytics: pick('analytics'), marketing: mk, preferences: pick('preferences'), sale_of_data: mk });
      } else {
        finish({ analytics: true, marketing: true, preferences: true, sale_of_data: true });
      }
    });
    box.querySelector('[data-acs-decline]').addEventListener('click', function () {
      finish({ analytics: false, marketing: false, preferences: false, sale_of_data: false });
    });
    manage.addEventListener('click', function () {
      prefs.hidden = false;
      manage.hidden = true;
      accept.textContent = 'Save preferences';
      var first = box.querySelector('[data-acs="analytics"]');
      if (first) first.focus();
    });
  }

  function start() {
    if (saved) return;
    loadApi(function (cp) {
      if (decided(cp)) return;
      show(cp);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
